import { urlScan } from "./constans";

const utils = {
    buildUrl: function (to: string, options: any) {
        if (options) {
            var params: any = {};
            if (options.redirectUri) {
                params.redirectUri = options.redirectUri;
            }
            if (options.correlationID) {
                params.cid = options.correlationID;
            }
            return this.addRequestParams(to, params);
        }
        return to;
    },

    addRequestParams: function (url: string, params: any) {
        url = this.stripPreviousResult(url);
        if (url && params) {
            var paramsAsString = new window.URLSearchParams(params).toString();
            if (url && url.indexOf('?') > 0) {
                return url + '&' + paramsAsString;
            } else {
                return url + '?' + paramsAsString;
            }
        }
        return url;
    },

    stripPreviousResult: function (url: string) {
        var validResultParams = ['error', 'status', 'transactionHash', 'signedTransaction', 'r', 's', 'v', 'signature', 'walletId'];
        var regex = new RegExp(/[?|&]([^=]+)=([^&]+)/g);
        var newUrl = url;
        var requestParam = regex.exec(url);
        while (requestParam) {
            if (validResultParams.includes(requestParam[1])) {
                if (newUrl.search('\\\\?' + requestParam[1] + '=.+&') > -1) {
                    newUrl = newUrl.replace(requestParam[1] + '=' + requestParam[2] + '&', '');
                } else if (newUrl.search('\\?' + requestParam[1]) > -1) {
                    newUrl = newUrl.replace('?' + requestParam[1] + '=' + requestParam[2], '');
                } else {
                    newUrl = newUrl.replace('&' + requestParam[1] + '=' + requestParam[2], '');
                }
            }
            requestParam = regex.exec(url);
        }
        return newUrl;
    },

    addHiddenInput: function (form: HTMLFormElement, name: string, value: string) {
        var newInput = document.createElement('input');
        newInput.type = 'hidden';
        newInput.name = name;
        newInput.value = value;
        form.appendChild(newInput);
    },

    getQueryParam: function (name: string, search: string) {
        var params = new window.URLSearchParams(search);
        var result = params.get(name);
        if (result === null) {
            return null;
        }
        return decodeURIComponent(result) || 0;
    },

    extractResultFromQueryParams: function (validResultParams: any, search: string) {
        var result = {};
        var params = new window.URLSearchParams(search);
        var keys = params.keys();
        var key = keys.next();
        while (!key.done) {
            if (validResultParams.includes(key.value)) {
                var asObject: any = {};
                asObject[decodeURIComponent(key.value)] = decodeURIComponent(params.get(key.value) as string);
                Object.assign(result, asObject);
            }
            key = keys.next();
        }
        return result;
    },

    createResult: function (validResultParams: any, search: string) {
        const status = this.getQueryParam('status', search);
        if (status === 'SUCCESS') {
            return { status: status, result: this.extractResultFromQueryParams(validResultParams, search) };
        } else if (status === 'ABORTED') {
            return { status: status, errors: [] };
        } else if (status === 'FAILED') {
            var errorObject = this.extractResultFromQueryParams(validResultParams, search);
            return { status: status, errors: [(errorObject as any).error] };
        } else {
            return { status: status };
        }
    }
}

export default utils

export const minimizeAddress = (address: string | undefined, numChar?: number) => {
    if (address === undefined) {
        return ""
    }
    numChar = numChar ? numChar : 5
    const lenth = address.length;
    const first = address.substring(0, numChar)
    const last = address.substring(lenth - numChar, lenth)
    return first + "..." + last
}

export const formatTime= (value) =>{
    let result = new Date(Number(value)*1000).toISOString();
    return result.replace('T', ' ').replace('Z','');
}

export const urlTransactions = (hash) =>{
    const chain = process.env.REACT_APP_CHAIN;
    if(chain && hash){
        return `${urlScan[chain]}/tx/${hash}`
    }
    return '#'
}